import { useGetIdentity } from "ra-core";
import {
  isModuleEnabled,
  isModuleAutomationEnabled,
  isModuleFeatureEnabled,
  moduleOption,
  type ModuleId,
  type OrgModulesState,
} from "@/modules/registry";

/** The signed-in member's company modules (loaded with the identity). */
export const useOrgModules = () => {
  const { identity } = useGetIdentity();
  const state = (identity as { org_modules?: OrgModulesState | null })
    ?.org_modules;
  return {
    state,
    isEnabled: (moduleId: ModuleId) => isModuleEnabled(state, moduleId),
    /** A function inside a module (Apps → module → Features). */
    hasFeature: (moduleId: ModuleId, key: string) =>
      isModuleFeatureEnabled(state, moduleId, key),
    /** Something the app does on its own (Apps → module → Automations). */
    automationOn: (moduleId: ModuleId, key: string) =>
      isModuleAutomationEnabled(state, moduleId, key),
    /** A module option such as Accounts → People only. */
    option: (moduleId: ModuleId, key: string) =>
      moduleOption(state, moduleId, key),
  };
};
